var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 434,
    height: 434,
    viewBox: "0 0 434 434",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 217,
    r: 217,
    fill: "#E1E2E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5355_17973)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.8562,
    cy: 157.856,
    r: 12.8562,
    fill: "#91CCD1",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 145,
    width: 230,
    height: 26,
    rx: 4,
    fill: "#91CCD1",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.905,
    cy: 216.448,
    r: 12.8562,
    fill: "#4EB072",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 204,
    width: 243,
    height: 25,
    rx: 4,
    fill: "#4EB072",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.8562,
    cy: 275.04,
    r: 12.8562,
    fill: "#91CCD1",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 262,
    width: 230,
    height: 26,
    rx: 4,
    fill: "#91CCD1",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 197,
    r: 19,
    fill: "#4EB072",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378 196.742L381.799 201.924L388.909 193",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5355_17973",
    x: 50,
    y: 144,
    width: 362,
    height: 157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.178196 0 0 0 0 0.243137 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5355_17973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5355_17973",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/Information.afd18d234907b31dce2b0a4f428e3a21.svg";
export { ForwardRef as ReactComponent };